import { createContext } from "react";

// Lets a page (e.g. an article) tell the header where the same page lives in each language:
// { fr: "/blog/slug-fr", en: "/en/blog/slug-en", ru: "/ru/blog/slug-ru" }.
const AlternatesContext = createContext(() => {});

export default AlternatesContext;
